module.exports = __webpack_public_path__ + "img/icon_map_53_off_111.6f81752c.png";